class MainArticle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.navActiveIndex = 0;
    this.sections = this.querySelectorAll('[data-section]');
    this.navLinks = this.querySelectorAll('[data-nav-link]');
    this.mobileNavLinks = this.querySelectorAll('[data-nav-link-mobile]');
    this.menu = this.querySelector('[data-menu]');
    window.addEventListener('scroll', this.handleScrollSpy.bind(this));
  }

  toggleActiveLink(link, flag = false) {
    if (!this.navLinks[link]) return;
    return this.navLinks[link].classList.toggle('is-active', flag);
  }

  unsetAllActiveLinks() {
    return [...Array(this.sections.length).keys()].forEach((link) =>
      this.toggleActiveLink(link),
    );
  }

  handleScrollSpy() {
    const sectionMargin = 200;
    const current =
      this.sections.length -
      [...this.sections]
        .reverse()
        .findIndex(
          (section) => window.scrollY >= section.offsetTop - sectionMargin,
        ) -
      1;
    const currentSectionIndex = current + 1;

    if (current !== this.sectionActiveIndex) {
      this.unsetAllActiveLinks();
      this.sectionActiveIndex = current;
      this.toggleActiveLink(current, true);
    }

    this.setProgress(
      currentSectionIndex > this.sections.length ? 0 : currentSectionIndex,
    );
  }

  setProgress(index) {
    const progressPercentage = (index / this.sections.length) * 100;
    this.style.setProperty(
      '--article-content-progress',
      `${progressPercentage}%`,
    );
    this.toggleMenu(index !== 0);
  }

  toggleMenu(flag) {
    this.menu.classList.toggle('is-visible', flag);
  }
}

customElements.define('main-article', MainArticle);
